import { useState, useEffect } from 'react'
import { gql } from '@apollo/client'
import { Alert, Input } from 'reactstrap'
import Spinner from '../../Spinner/Spinner.js'
import { USER_CALENDARS_QUERY } from '../../../graphql.js'
import { handleGraphQLErrors } from '../../../utils.js'

export const USER_CALENDARS = gql(USER_CALENDARS_QUERY)

export default function UserCalendars({ handleChange }) {
  console.log('UserCalendars rendered')

  const [items, setItems] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])

  useEffect(() => {
    async function fetchItems() {
      try {
        const { data, errors } = await window.apolloClient.query({ query: USER_CALENDARS, fetchPolicy: 'cache-first' })
        if (data.userCalendars) {
          const menuItems = [<option key={0} value={null}></option>]
          for (let item of data.userCalendars) {
            menuItems.push(<option key={item.id} value={item.id}>{item.name}</option>)
          }
          setItems(menuItems)
        }
        if (errors) {
          setGraphQLErrors(errors)
        }
      } catch (err) {
        handleGraphQLErrors(err, setGraphQLErrors)
      }
    }
    if (!items) {
      fetchItems()
    }
  }, [items])

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  }
  if (items) {
    return (
      <Input type="select" name="calendar" onChange={handleChange}>
        {items}
      </Input>
    )
  } else {
    return <Spinner />
  }
}
